<div>
    <div class="cancel_details">
        <div class="dlt">
            <div>
                <img src="assets/image/checkmark.png" alt="Daysheet close confirmation">
            </div>
            <div>
                <span class="Dlt_title">Daysheet Submit</span>
            </div>
        </div>
        <p class="dlt_mge">{{ data.confirmMessage || 'Do you want to submit the daysheet details?' }}</p>
        <div class="selected_list">
            <button class="cancel" (click)="cancel()">Cancel</button>
            <button class="delete" (click)="daysheetClose()">{{ data.confirmLabel || 'Daysheet Submit' }}</button>
        </div>
    </div>
</div>
